<div id="toggler" class="d-flex py-2" (click)="isCollapsed = !isCollapsed">
    <div class="col-1">
        <fa-icon [icon]="isCollapsed ? faChevronDown : faChevronUp" aria-hidden="true"></fa-icon>
    </div>
    <div class="col-3 user-select-auto text-break" id="material-num">
        {{ material.materialIdentifier.materialNumber.value }}
    </div>
    <div class="col-4 user-select-auto text-break">
        {{ material.description.value }}
        @if (displayAdditionalMaterialRequestInformation && material.orderInfoText) {
            <fa-icon [icon]="faInfoCircle" class="ms-1" (click)="openInfoText($event, material.orderInfoText)">
            </fa-icon>
        }
    </div>
    <div class="col-4 user-select-auto">
        <!-- Bootstock return does not have notification number. Show bootstock return. -->
        @if (material.notificationIdentifier.qmNum) {
            {{ material.notificationIdentifier.qmNum }}
        } @else if (material.isBootstockReturn) {
            {{ 'BOOTSTOCK_RETURN_TITLE' | translate }}
        } @else if (material.isBootStockScrapable) {
            {{ 'BOOTSTOCK_SCRAP_TITLE' | translate }}
        }
        <br />
        @if (showStatusStringButton) {
            <span>
                <button (click)="openMaterialReturn()" class="btn btn-primary btn-sm">
                    {{ material.statusString.value | translate }}
                </button>
            </span>
        }
        @if (showStatusString) {
            <span>{{ material.statusString.value | translate }}</span>
        }
        @if (showAwbReturn) {
            <span class="content-break-word">{{ material.awbReturn.value }}</span>
        }
    </div>
</div>
@if (!isCollapsed) {
    <div class="py-3 offset-1 d-lg-flex flex-lg-wrap">
        <div class="row align-items-center">
            <label
                translate="DASHBOARD_SIDEMENU_MATERIAL_HISTORY_PURCHASE_NUMBER"
                class="col-6 col-lg-3 col-form-label text-start text-lg-end"
            ></label>
            <div class="col-6 col-lg-3 text-break">{{ material.materialIdentifier.orderNumber.value }}</div>
            <label
                translate="DASHBOARD_SIDEMENU_MATERIAL_HISTORY_PURCHASE_ORDER"
                class="col-6 col-lg-3 col-form-label text-start text-lg-end"
            ></label>
            <div class="col-6 col-lg-3 text-break">{{ material.materialIdentifier.orderPosition.value }}</div>
            <label
                translate="DASHBOARD_SIDEMENU_MATERIAL_HISTORY_BATCH_NUMBER"
                class="col-6 col-lg-3 col-form-label text-start text-lg-end"
            ></label>
            <div class="col-6 col-lg-3 text-break">{{ material.batchNumber.value }}</div>
            <label
                translate="DASHBOARD_SIDEMENU_MATERIAL_HISTORY_RETURN_LOCATION"
                class="col-6 col-lg-3 col-form-label text-start text-lg-end"
            ></label>
            <div class="col-6 col-lg-3">
                @if (
                    material.materialStatus.isReturnedOrRequested &&
                    material.deliveryReturnSelectedOption === customerAddress
                ) {
                    <fa-icon [icon]="faUsers"> </fa-icon>
                }
                @if (
                    material.materialStatus.isReturnedOrRequested &&
                    material.deliveryReturnSelectedOption === dopAddress
                ) {
                    <fa-icon [icon]="faBuilding"> </fa-icon>
                }
                @if (
                    material.materialStatus.isReturnedOrRequested &&
                    material.deliveryReturnSelectedOption === taxiAddress
                ) {
                    <fa-icon [icon]="faTaxi"> </fa-icon>
                }
                @if (
                    material.materialStatus.isReturnedOrRequested &&
                    material.deliveryReturnSelectedOption === fedexAddress
                ) {
                    <fa-icon [icon]="faShippingFast"> </fa-icon>
                }
                @if (displayAdditionalMaterialRequestInformation && material.orderPriority) {
                    <span class="ps-2">
                        @if (material.orderPriority === HIGH) {
                            <fa-icon [icon]="faLongArrowAltUp"></fa-icon>
                        }
                        @if (material.orderPriority === MEDIUM) {
                            <fa-icon [icon]="faAngleDoubleUp"></fa-icon>
                        }
                        @if (material.orderPriority === LOW) {
                            <fa-icon [icon]="faAngleDoubleDown"></fa-icon>
                        }
                    </span>
                }
            </div>
            <label
                translate="DASHBOARD_SIDEMENU_MATERIAL_HISTORY_DATE"
                class="col-6 col-lg-3 col-form-label text-start text-lg-end"
            ></label>
            <div class="col-6 col-lg-3 text-break">{{ material.activityDate.formattedDisplayedDate }}</div>
            <label
                translate="DASHBOARD_SIDEMENU_MATERIAL_HISTORY_AWB_PACKAGING"
                class="col-6 col-lg-3 col-form-label text-start text-lg-end"
            ></label>
            <div class="col-6 col-lg-3 text-break">{{ material.awbPackagingText }}</div>
        </div>
    </div>
}
